<div class="controls">
    <div class="left">
        <lightswitch labelLeft="Show unread" labelRight="Show all" [status]="showAll" (changeStatus)="handleShowAllChange()"></lightswitch>
    </div>
    <div class="right">
        <a class="read-all" (click)="markAllAsRead()">Mark all as read</a>
    </div>
</div>